import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import CatalogPageShell from "../components/Products/CatalogPageShell.jsx";
import BuyerViewSearch from "../components/Products/BuyerViewSearch.jsx";
import BuyerProductGrid from "../components/Products/BuyerProductGrid.jsx";
import DimensionGrid from "../components/Products/DimensionGrid.jsx";
import TabNavigation from "../components/TabNavigation.jsx";
import { CATALOG_TABLES } from "./CatalogRecords.jsx";
import "../components/InventoryUpload/uploadProducts.css";

const TABS = [
    { label: "Search", value: 0 },
    { label: "Products", value: 1 },
    { label: "Brand List", value: 2 },
];

const BRAND_SPEC = {
    ...CATALOG_TABLES.brands,
    title: "brand list",
    /** Brands linked to at least one SKU with a Vista/MAC/auction price above $0.50. */
    queryParams: { buyerActive: "1" },
};

export default function BuyerView() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [tab, setTab] = useState(() => {
        const initial = Number(searchParams.get("t"));
        return initial === 1 || initial === 2 ? initial : 0;
    });

    const changeTab = (_event, next) => {
        setTab(next);
        setSearchParams({ t: String(next) });
    };

    return (
        <CatalogPageShell
            title="Buyer View"
            subtitle="Search a SKU for auction pricing, browse product prices, or manage brand ciphers."
        >
            <div className="app-page-stack">
                <div style={{ flexShrink: 0 }}>
                    <TabNavigation value={tab} onChange={changeTab} tabs={TABS} />
                </div>
                {tab === 2 ? (
                    <DimensionGrid key="buyer-brands" spec={BRAND_SPEC} />
                ) : tab === 1 ? (
                    <BuyerProductGrid key="buyer-products" />
                ) : (
                    <div className="upload-stack">
                        <div className="upload-stack-body buyer-search-body">
                            <BuyerViewSearch />
                        </div>
                    </div>
                )}
            </div>
        </CatalogPageShell>
    );
}
